import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import {
    createStore,
    applyMiddleware,
    compose
} from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers/combineReducers';
import './index.css';
import './styles/css/weather-icons.css'
import './styles/css/weather-icons-wind.css'
// import './config/axiosInterceptor'
import App from './components/App';
import App2 from './layout2.0/App2';
import { loadCSS, cssSelector } from './JS/cssImport'
import './styles/css/normalize.css';
// //import './styles/bootstrap.scss';
// import './styles/css/bootstrap.css';
// //import './styles/default.scss';
import './styles/css/font-awesome.css';
// import { initializeApp } from "firebase/app";
// import { getPerformance } from "firebase/performance";
// import { getAnalytics } from "firebase/analytics";
//import './styles/css/default.css'
//import './JS/heightFix'
//import './theme/theme.css'
//import './theme/default_theme.css'
import './styles/css/pre-loader.css'
import './styles/css/overlay.css'
import { LayoutMaster, CMSPath, LANDSCAPE_ON_TABLET } from './config/constant'
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import common_fr from "./translations/fr/fr_translations.json";
import common_en from "./translations/en/en_translations.json";
import common_es from "./translations/es/es_translations.json";
import common_zh_CHS from "./translations/zh_CHS/zh_CHS_translations.json";
import common_zh_CHT from "./translations/zh_CHT/zh_CHT_translations.json";
import common_de from "./translations/de/de_translations.json";
import $ from 'jquery'
import ErrorBoundary from './layout2.0/components/home/ErrorBoundry';
import { GetTranslationKeys } from './JS/configTranslationKeys';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
    reducers,
    composeEnhancers(applyMiddleware(thunk))
);


const updateAdditionalTraslationResources = async () => {

    const translationResources = await getLanguage();

    Object.keys(translationResources).forEach(language => {
        const resourceBundle = translationResources[language];
        i18next.addResourceBundle(language, 'translations', resourceBundle.translations, false, true);
    });
}

async function getLanguage(){

    let language = {
        en : {
            translations : common_en
        }
    };

    try {

        const headerConfig = {
            headers: { Authorization: `Bearer ${localStorage.getItem("GuestJourneySessionToken")}` }
        };

        let langResponse;

        if (process.env.REACT_APP_HARDCODE_LANGUAGE_APIS === "true") {
            console.log("using default en lang");
            
            langResponse = {
                ok: true,
                json: async () => ({
                    payload: [
                        {
                            languageCode: "en",
                            language: "English"
                        }
                    ]
                })
            };
        } else {
            langResponse = await fetch(`${CMSPath}/Connector/rest/assets?type=localisation`, headerConfig);
        }

        if(langResponse.ok){
            const data = await langResponse.json();
            console.log("success getting translation lng")
            
            let resourcesLng = {}

            for (var i=0; i<data.payload.length; i++){

                const newLang = data.payload[i].languageCode;
                resourcesLng[newLang] = {
                    translations : await GetTranslationKeys(newLang)
                }

            }

            return resourcesLng
        } else {
            console.log("error while fetch translation languages")

            return language
        }
    } catch (error) {
        console.log("error while getting translation keys")
        console.log(error)

        return language
    }
}

function i18nextInit(){
    i18next.init({
        interpolation: { escapeValue: false },  // React already does escaping
        lng: 'en',                              // language to use
        fallbackLng: 'en',
        resources: {
            en: {
                translations: common_en
            }
        },
    });

    updateAdditionalTraslationResources();
}

const startApp = async () => {

    if (process.env.NODE_ENV === 'production') {
        console.log = () => {};
        console.error = () => {};
        console.warn = () => {};
        console.debug = () => {};
        console.info = () => {};
    }

    i18nextInit();

    $("body").removeClass("overlay")
    $("body").removeClass("preloader");
    $("#root").removeClass("preload-container")

    window.document.title = process.env.REACT_APP_TITLE || 'The Digital Guest Journey';

    if (LayoutMaster === "webapp-type1") {
        loadCSS("layout_1/default.css")
        // loadCSS("layout_1/theme.css")
        // loadCSS("http://83.233.76.163:8080/cmsData/guestJourneyCss/custom_css.css")
        loadCSS("layout_1/default_theme.css")
        loadCSS("layout_1/bootstrap.css")
        //console.log("window",window.device);
        ReactDOM.render(<Provider store={store} >
            <I18nextProvider i18n={i18next}>
                <ErrorBoundary>
                    <App2 />
                </ErrorBoundary>
            </I18nextProvider>
        </Provider>,
            document.getElementById('root')
        );
    } else if (LayoutMaster === "webapp-type2") {
        loadCSS("layout_2/css/default.css")
        loadCSS("layout_2/theme/theme.css")
        // loadCSS(`${CMSPath}/cmsData/guestJourneyCss/custom_css.css`)
        loadCSS("layout_2/css/font-awesome.css")
        loadCSS("layout_2/fa/css/fontawesome.css")
        //console.log("window",window.device);
        ReactDOM.render(<Provider store={store} >
            <I18nextProvider i18n={i18next}>
                <ErrorBoundary>
                    <App2 />
                </ErrorBoundary>
            </I18nextProvider>
        </Provider>,
            document.getElementById('root')
        );
    }
}

const startCordovaApp = async () => {

    i18nextInit();

    $("body").removeClass("overlay")
    $("body").removeClass("preloader");
    $("#root").removeClass("preload-container")
    
    // var Sentry = window.cordova.require('sentry-cordova.Sentry');
    // Sentry.init({ dsn: 'https://39b38de67cbc1b502f27cb42d0ea332b@o4509429225160704.ingest.us.sentry.io/4509429230731264' });
    if (window.device && window.screen) {
        console.log("window.device.platform", window.device.platform);
        if (window.isTablet) {
            if (LANDSCAPE_ON_TABLET) {
                window.screen.orientation.lock && window.screen.orientation.lock('landscape');
            } else {
                window.screen.orientation.lock && window.screen.orientation.lock('portrait');
            }
            console.log("window.device.platform isTablet", window.device.platform);
        } else {
            window.screen.orientation.lock && window.screen.orientation.lock('portrait');
        }
    }

    let platform = window.device.platform
    if (platform == 'Android') {
        $("#myBody").addClass("android")
    } else if (platform == 'iOS') {
        $("#myBody").addClass("ios")
    }

    // cssSelector()
    if (LayoutMaster === "webapp-type1") {
        loadCSS("layout_1/default.css")
        // loadCSS("layout_1/theme.css")
        // loadCSS(`${CMSPath}/cmsData/guestJourneyCss/custom_css.css`)
        loadCSS("layout_1/default_theme.css")
        loadCSS("layout_1/bootstrap.css")
        ReactDOM.render(
            <Provider store={store} >
                <I18nextProvider i18n={i18next}>
                    <ErrorBoundary>`
                        <App2 />`
                    </ErrorBoundary>
                </I18nextProvider>
            </Provider>,
            document.getElementById('root')
        );
    } else if (LayoutMaster === "webapp-type2") {
        loadCSS("layout_2/css/default.css")
        loadCSS("layout_2/theme/theme.css")
        // loadCSS(`${CMSPath}/cmsData/guestJourneyCss/custom_css.css`)
        loadCSS("layout_2/css/font-awesome.css")
        loadCSS("layout_2/fa/css/fontawesome.css")
        ReactDOM.render(<Provider store={store} >
            <I18nextProvider i18n={i18next}>
                <ErrorBoundary>
                    <App2 />
                </ErrorBoundary>
            </I18nextProvider>
        </Provider>,
            document.getElementById('root')
        );
    }
}

$("body").addClass("overlay")
$("body").addClass("preloader");
$("#root").addClass("preload-container")

 
// const firebaseConfig = {
//   apiKey: "AIzaSyAfdmozggOeDLyIaZ4n1Pqe_mvPdgRS90w",
//   authDomain: "innspire-guestjourney-dev3.firebaseapp.com",
//   projectId: "innspire-guestjourney-dev3",
//   storageBucket: "innspire-guestjourney-dev3.firebasestorage.app",
//   messagingSenderId: "139038228968",
//   appId: "1:139038228968:web:e61a7e8f3121741002e45d",
//   measurementId: "G-FXR7F4WMDD"
// };

// // Initialize Firebase
// export const appFb = initializeApp(firebaseConfig);
// export const analytics = getAnalytics(appFb);
// export const perf = getPerformance(appFb);

if (window.cordova) {
    console.log("window.cordova", window.cordova);
    document.addEventListener('deviceready', startCordovaApp, false);
} else {
    startApp();
}
